import React from 'react';

import moment from 'moment';

import { Text } from '@qality/common-components/src/atoms/Text';
import { ExecutionsSummary as IExecutionsSummary } from '@qality/common-model';
import { StorageOfUniqueServices } from '@qality/common-service';
import { ExecutionStatusUtils } from '@qality/common-utils';

import { ExecutionStatusSummary } from '../../execution-status-summary/ExecutionStatusSummary';
import {
  ContainerStyled,
  EllipseStyled,
  LatestExecutionStyled,
  StatusTextStyled,
} from './ExecutionsSummary.styled';

type Props = {
  executionsSummary: IExecutionsSummary;
};

const NO_EXECUTIONS_IN_RANGE_MESSAGE = 'No executions in range';

export function ExecutionsSummary({ executionsSummary }: Props): JSX.Element {
  if (!executionsSummary) {
    return <Text noData>{NO_EXECUTIONS_IN_RANGE_MESSAGE}</Text>;
  }

  const areExecutionsInRange = !ExecutionStatusUtils.isStatusSummaryEmpty(
    executionsSummary.statuses
  );

  const lastExecutionUrl = StorageOfUniqueServices.get(
    'URLService'
  ).getTestCaseExecutionUrl(executionsSummary.lastExecutionId);

  const executionHistoryUrl = StorageOfUniqueServices.get(
    'URLService'
  ).getTestCaseExecutionHistoryUrl(
    executionsSummary.testCaseKey,
    executionsSummary.testCaseKey
  );

  const executionHistoryLinkMessage =
    executionsSummary.numberOfExecutions === 1
      ? '1 test execution'
      : executionsSummary.numberOfExecutions + ' test executions';

  return (
    <ContainerStyled>
      {areExecutionsInRange ? (
        <>
          <a target='_BLANK' href={executionHistoryUrl} rel='noreferrer'>
            {executionHistoryLinkMessage}
          </a>
          <ExecutionStatusSummary statusSummary={executionsSummary.statuses} />
        </>
      ) : (
        <Text noData>{NO_EXECUTIONS_IN_RANGE_MESSAGE}</Text>
      )}
      <LatestExecutionStyled>
        Latest:&nbsp;
        <a target='_BLANK' href={lastExecutionUrl} rel='noreferrer'>
          {moment(executionsSummary.lastCreatedDate).format('DD/MMM/YYYY')}
        </a>
        <EllipseStyled />
        <StatusTextStyled>{executionsSummary.lastStatus.name}</StatusTextStyled>
      </LatestExecutionStyled>
    </ContainerStyled>
  );
}
